<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'modelosCrud'" crudName="Modelos" newText="Novo Modelo" :table="table" :columns="columns"
          :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true"
          :enableView="false" :enableReset="false" :dataForm="dataForm" :extra="extra" @openModal="openModal">
        </base-crud>
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="'exampleModalLabel'"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modelo: {{ modelo.id }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group col-md-12">
                  <label for="Name">
                    <span class="required">*</span> Unidade:
                  </label>
                  <v-select :options="unidades" :label="'unidade_nome'" :reduce="(unidades) => unidades.id"
                    v-model="modelo.unidade_id"></v-select>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-back" data-dismiss="modal">Fechar</button>
                <a class="btn btn-add ml-1" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "modelosTable",
      showMessageImport: false,
      modelosCrud: {},
      pages: [],
      modelo: {
        id: '',
        unidade_id: ''
      },
      unidades: [],
      url: "",
      columns: ["id", "titulo", "actions"],
      tableData: ["id", "titulo"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          titulo: "Título",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {

        },
        templates: {

        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [{
        id: 1,
        label: "",
        class: "btn btn-crud view",
        title: "Adicionar modelo",
        name: "openModal",
        icon: "fas fa-plus",
      }],
      endPoint: "modelos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {

    openModal(props, row) {
      this.modelo.id = props.row.id;
      $('#exampleModal').modal('show');
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "modelo_perguntas/salvar_modelo";

      axios
        .post(api, {modelo_id: self.modelo.id, unidade_id: self.modelo.unidade_id})
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/modelos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },



    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-modelos";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.modelosCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        titulo: "titulo",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
  mounted: function () {
    const self = this;
    self.getUnidades();

  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>